import {
  isNumber
} from '../../helper/index.js';

// Node= {key, value, next, prev}

const LRUCache = function(capacity) {
  if (!isNumber(capacity)) {
    throw new Error(`capacity ${capacity} of LRUCache is not a number`);
  }

  if (capacity < 0) {
    throw new Error(`capacity ${capacity} of LRUCache is less than 0`);
  }

  this.capacity = capacity;

  this.head = {};
  this.tail = {};
  this.head.next = this.tail;
  this.tail.prev = this.head;

  this.nodeMap = {}; // key-node
};

LRUCache.prototype = {
  has: function(key) {
    const node = this.nodeMap[key];
    return !!node;
  },

  get: function(key) {
    // 1. get node from map
    const node = this.nodeMap[key];
    if (!node) {
      return undefined;
    }

    // 2. after visited, move it to tail
    this._moveNodeToTail(node);
    return node.value;
  },

  set: function(key, value) {
    let node = this.nodeMap[key];
    if (!node) { // new key
      node = {
        key,
        value,
      };

      // append visited node to tail
      this._appendNodeToTail(node);
      this.nodeMap[key] = node;
    }

    // remove if exceed capacity
    if (Object.keys(this.nodeMap).length > this.capacity) {
      const removed = this._removeNode(this.head.next);
      delete this.nodeMap[removed.key];
    }
  },

  remove: function(key) {
    const node = this.nodeMap[key];
    if (!node) return;

    this._removeNode(node);
    delete this.nodeMap[key];
  },

  _moveNodeToTail: function(node) {
    this._removeNode(node);
    this._appendNodeToTail(node);
  },

  _appendNodeToTail: function(node) {
    const prev = this.tail.prev;
    prev.next = node;
    node.prev = prev;
    node.next = this.tail;
    this.tail.prev = node;
  },

  _removeNode: function(node) {
    const prev = node.prev;
    const next = node.next;

    prev.next = next;
    next.prev = prev;

    return node;
  },
};

export {
  LRUCache
};
